export default __webpack_public_path__ + "static/LTZ_TABLET-fe09d4be6a97f92e407c125df687848a.jpg";